import uniqueId from "lodash/uniqueId";
import {
  CustomValueOption,
  CustomValueSelect
} from "PFApp/components/custom_value_select/custom_value_select";
import { getCustomValueOptionId } from "PFCore/helpers/options/custom_values_options";
import { PureCustomValueData } from "PFTypes";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import { useCommonProps } from "../use_common_props";
import { buildCommonSelectProps, SelectFieldConfig } from "./select_custom_value_field.utils";

type SelectCustomValueFieldProps = {
  commonProps: ReturnType<typeof useCommonProps>;
  config: SelectFieldConfig;
  values: PureCustomValueData[];
  isMulti: boolean;
  handleChange: (values: PureCustomValueData[]) => void;
};

export const SelectCustomValueField = ({
  commonProps,
  config,
  values,
  isMulti,
  handleChange
}: SelectCustomValueFieldProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "customValues" });
  const dropdownId = useRef(uniqueId("select-dropdown"));

  const commonSelectProps = buildCommonSelectProps({
    ...config,
    dropdownIdPrefix: dropdownId.current,
    values,
    locked: commonProps.locked,
    handleChange,
    createDescriptionTip: config.customType?.name === "skills" ? t("createDescription.skills") : undefined
  });

  return isMulti ? (
    <CustomValueSelect
      multiple
      value={values.map(getCustomValueOptionId)}
      onChange={(options: CustomValueOption[]) => handleChange(options.map(({ original }) => original))}
      {...commonSelectProps}
      {...commonProps}
    />
  ) : (
    <CustomValueSelect
      value={values[0] && getCustomValueOptionId(values[0])}
      onChange={(option: CustomValueOption) => handleChange([option.original])}
      {...commonSelectProps}
      {...commonProps}
    />
  );
};
